import { Button } from "primereact/button";
import { Panel } from "primereact/panel";

import { useEffect, useRef, useState, memo } from "react";
import { useReport } from "../../context/report";

import { useReactToPrint } from "react-to-print";

import { GraficoMetragemDia } from "./GraficoMetragemDia";

export const MetragemDiaGrupos = memo(function MetragemDiaGrupos() {
    const { data } = useReport();

    const [printing, setPrinting] = useState(false);
    const [printingV2, setPrintingV2] = useState(false);
    const [charts, setCharts] = useState([]);

    const page = useRef();

    const handlePrint = useReactToPrint({
        content: () => page.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setPrinting(true);
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
            setPrinting(false);
        }
    });

    const handlePrintV2 = useReactToPrint({
        content: () => page.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setPrintingV2(true);
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
            setPrintingV2(false);
        }
    });

    useEffect(() => {
        let dados = data.metragem_grupo.dados;
        let grupos = data.metragem_grupo.grupos;
        let array = [];

        let labels = [];
        let dataset = [];

        let date = null;
        let total = 0;

        dados.forEach((item, index) => {
            let month = String(item.data).substring(5, 7).padStart(2, '0');
            let day = String(item.data).substring(8, 10).padStart(2, '0');

            let formated = day + '/' + month;

            if(date === null) {
                date = formated;
                total = parseFloat(item.total);
            } else if(date === formated) {
                total += parseFloat(item.total);
            } else {
                dataset.push(total);
                date = formated;
                total = parseFloat(item.total);
            }

            if(index + 1 === dados.length) {
                dataset.push(total);
            }

            if(labels.indexOf(formated) === -1) {
                labels.push(formated);
            }
        });

        let object = {};
        object.labels = labels;
        object.datasets = [{ label: 'Turma', data: dataset, backgroundColor: "#2ecc71" }]

        array.push(object);

        grupos.forEach((element) => {
            let filtered = dados.filter((item) => {
                return item.grupo === element;
            });

            let labels = [];
            let dataArr = [];
            let eficienciasGrupo = [];
            filtered.forEach((item) => {
                let month = String(item.data).substring(5, 7).padStart(2, '0');
                let day = String(item.data).substring(8, 10).padStart(2, '0');

                labels.push(day + '/' + month);
                dataArr.push(item.total);
                eficienciasGrupo.push(item.eficiencia_media);
            });

            let object = {};
            object.labels = labels;
            object.datasets = [{
                label: 'Grupo ' + element,
                data: dataArr,
                backgroundColor: "#e74c3c",
                eficiencias: eficienciasGrupo
            }];
            array.push(object);
        });

        setCharts(array);
    }, [data]);

    const getPeriodoRelatorio = () => {
        if (!data?.metragem_grupo?.dados || data.metragem_grupo.dados.length === 0) return "";
        
        let dados = data.metragem_grupo.dados;
        
        let pData = String(dados[0].data);
        let dataInicio = `${pData.substring(8, 10).padStart(2, '0')}/${pData.substring(5, 7).padStart(2, '0')}/${pData.substring(0, 4)}`;
        
        let uData = String(dados[dados.length - 1].data);
        let dataFim = `${uData.substring(8, 10).padStart(2, '0')}/${uData.substring(5, 7).padStart(2, '0')}/${uData.substring(0, 4)}`;

        return `${dataInicio} a ${dataFim}`;
    };

    const isPrinting = printing || printingV2;
    const tituloPeriodo = getPeriodoRelatorio();

    return (
        <Panel header="GRÁFICO DE METRAGEM POR DIA" toggleable>
            <div>
                <Button
                    className="p-m-2"
                    icon="pi pi-print"
                    onClick={handlePrint}
                />

                <Button 
                    className="p-m-2 p-button-danger"
                    icon="pi pi-print"
                    onClick={handlePrintV2}
                />

                <div className={isPrinting ? "" : "p-grid"} ref={page} style={{ width: '100%', margin: 0 }}>
                    
                    {isPrinting && (
                        <style type="text/css" media="print">
                            {`
                                @page { 
                                    size: landscape; 
                                    margin: 10mm; /* margem para a folha não cortar os cantos */
                                }
                            `}
                        </style>
                    )}

                    {data.metragem_grupo.dados && charts.map((item, index) => {
                        if(printingV2 && index === 0)
                            return null;
                        return (
                            <div 
                                className={isPrinting ? "" : "p-col-12 p-mb-4"} 
                                key={`chart${index}`} 
                                style={{ 
                                    width: '100%',
                                    pageBreakAfter: 'always', 
                                    pageBreakInside: 'avoid',
                                    paddingTop: isPrinting ? '20px' : '0'
                                }}
                            >
                                {isPrinting && (
                                    <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#000', fontFamily: 'sans-serif' }}>
                                        Metragem Produzida - {tituloPeriodo}
                                    </h2>
                                )}

                                <GraficoMetragemDia 
                                    data={item} 
                                    grupo={index === 0 ? 'Turma(s) ' + data.metragem_grupo.turma : 'Grupo ' + data.metragem_grupo.grupos[index - 1]}
                                    max={data.max} 
                                    printing={isPrinting} 
                                />
                            </div>
                        )
                    })}
                </div>
            </div>
        </Panel>
    )
});

